import React from 'react'

/**
 * App Context Defaults
 */
export const defaults = {
  fetching: false,
  developers: [],
  filterDevelopers: () => {},
  filters: {
    skill: [],
    role: [],
    experience: [],
  },
  isSelected: () => {},
  toggleFilter: () => {},
  selectedDevelopers: [],
  toggleDeveloper: () => {},
  step: 0,
  setStep: () => {},
  reset: () => {},
}

export default React.createContext(defaults)
